'use client';

import { ScrollAnimation } from '@/shared/components/ui/scroll-animation';
import { Section } from '@/shared/types/blocks/landing';

export function FAQ({
  section,
  className,
}: {
  section: Section;
  className?: string;
}) {
  return (
    <section id={section.id} className={`py-16 md:py-24 ${className}`}>
      <div className={`mx-auto max-w-full px-4 md:max-w-3xl md:px-8`}>
        <ScrollAnimation>
          <div className="mx-auto max-w-2xl text-center text-balance">
            <h2 className="text-foreground mb-4 text-3xl font-semibold tracking-tight md:text-4xl">
              {section.title}
            </h2>
            <p className="text-muted-foreground mb-6 md:mb-12 lg:mb-16">
              {section.description}
            </p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation delay={0.2}>
          <div className="mx-auto mt-12 max-w-full">
            <div className="bg-muted dark:bg-muted/50 w-full rounded-2xl p-1">
              {section.items?.map((item, idx) => (
                <details
                  className="group open:bg-card dark:open:bg-muted rounded-xl border-none px-7 py-1 open:shadow-sm"
                  key={idx}
                >
                  <summary className="cursor-pointer list-none py-4 text-base hover:no-underline [&::-webkit-details-marker]:hidden">
                    <span className="flex items-center justify-between gap-4">
                      {item.question || item.title || ''}
                      <span
                        aria-hidden
                        className="text-muted-foreground text-xl leading-none"
                      >
                        +
                      </span>
                    </span>
                  </summary>
                  <div className="pb-4">
                    <p className="text-base">
                      {item.answer || item.description || ''}
                    </p>
                  </div>
                  <hr className="mx-0 border-dashed group-last:hidden" />
                </details>
              ))}
            </div>

            <p
              className="text-muted-foreground mt-6 px-8"
              dangerouslySetInnerHTML={{ __html: section.tip || '' }}
            />
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
